import { Button } from "@mui/material";

function CSDelete({ deleteComponent }) {
  return (
    <div>
      <Button id="delete" variant="contained" fullWidth onClick={deleteComponent}>
        delete
      </Button>
    </div>
  );
}

export default CSDelete;